import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/mandala")({
  head: () => labHead(
    "/lab/mandala",
    "Mandala do Inconsciente",
    "Mandala do Inconsciente: uma obra pessoal em cor, forma e som, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: MandalaLab,
});

function MandalaLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/mandala/" title={{ pt: "Mandala do Inconsciente", en: "Mandala of the Unconscious", es: "Mandala del Inconsciente" }} />;
}